exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#image-review.table-responsive .vgt-responsive {\n  overflow-y: scroll;\n}\n#image-review.table-responsive .vgt-fixed-header {\n  max-width: 99%;\n  overflow: hidden;\n}\n#image-review.table-responsive table {\n  table-layout: fixed;\n  max-width: none;\n  width: 99%;\n  overflow: hidden;\n  border-collapse: separate !important; /* Don't collapse */\n  border-spacing: 0 !important;\n  word-wrap: break-word;\n}\n#image-review.table-responsive thead tr {\n  position: sticky !important;\n  top: 0;\n  z-index: 1;\n}", ""]);

// exports
